export default __webpack_public_path__ + "static/media/GigLinked_Illustrations_solo-artist.42aa7872.svg";